
    window.env = {
      VITE_GA_TAG: import.meta.env.VITE_GA_TAG,
      VITE_SERVER : import.meta.env.VITE_SERVER
    };
  